import { Localization } from "@viamap/viamap2-common";
import { Trash } from "iconsax-react";
import { useState } from "react";
import { ColorBoxEditableV2 } from "src/components/ComponentUtils";
import { GlassButton } from "src/components/GlassButtons";
import { ADModalBody, ADModalFooter, ADModalInfo, AdvancedDragModal } from "src/componentsUtils/AdvancedDragModal";
import { useWindowContext } from "src/WindowManager/useWindowContext";
import { closeWindow, ManagedWindow } from "src/WindowManager/WindowState";


export function BNBOStatusEditor(props: {
   managedWindow: ManagedWindow,
   disabled?: boolean,
   value?: { val: string, color: string, afsluttet?: boolean }[],
   onChange?: (value: any) => void,
   default?: { val: string, color: string, afsluttet?: boolean }[]
}) {

   const { dispatch } = useWindowContext();
   let [value, setValue] = useState(props.value || props.default || []);

   function handleIndexOnChange(index: number, value: { val: string, color: string, afsluttet?: boolean }) {
      setValue((val) => val.map((status, i) => {
         if (i === index) {
            return value;
         }
         return status;
      }))

   }

   function confirmChanges() {
      let output = value.map((status) => {
         return {
            val: status.val.trim(),
            color: status.color,
            afsluttet: status.afsluttet || false
         };
      }).filter((status) => status.val !== "");
      props.onChange?.(output);
      dispatch(closeWindow(props.managedWindow.id));
   }

   function handleAddNew() {
      const newStatus = { val: "", color: "#ffffff", afsluttet: false };
      setValue([...value, newStatus]);
   }

   function handleDelete(index: number) {
      setValue((val) => val.filter((_, i) => i !== index));
   }


   return (
      <AdvancedDragModal window={props.managedWindow} title="BNBO Status Editor" onClose={() => { dispatch(closeWindow(props.managedWindow.id)) }}
         PosDefault={{ width: "400px", left: "50%", top: "50%", transform: "translate(-50%, -50%)" }}
      >
         <ADModalInfo center={true}>
            Bemærk at ændringerne kun justerer hvilke statusser der er tilgængelige i BNBO, og ikke ændrer på eksisterende data, eller statusser.
         </ADModalInfo>
         <ADModalBody>

            <div style={{ display: "flex", flexDirection: "column", paddingLeft: "10px", gap: "2px", marginTop: "10px" }}>
               {value?.map((status, index) => (
                  <div key={index} className="GlassInputControl" style={{ display: "flex", alignItems: "center" }}>
                     <ColorBoxEditableV2
                        color={status.color}
                        onCommit={(color) => {
                           handleIndexOnChange(index, { ...status, color });
                        }}
                     />
                     <input disabled={props.disabled} value={status.val} style={{ flex: "auto" }} onChange={(e) => {
                        handleIndexOnChange(index, { ...status, val: e.target.value });
                     }} />
                     <select disabled={props.disabled} value={status.afsluttet ? "afsluttet" : "igang"} style={{ flex: "auto" }} onChange={(e) => {
                        handleIndexOnChange(index, { ...status, afsluttet: e.target.value === "afsluttet" });
                     }}>
                        <option value="igang">Igang</option>
                        <option value="afsluttet">Afsluttet</option>
                     </select>
                     {/* <GlassCheckbox checked={status.afsluttet} onClick={(e, checked) => {
                  handleIndexOnChange(index, {...status, afsluttet: checked});
               }} >Afsluttet</GlassCheckbox> */}
                     <div style={{ width: "4px", height: "2px" }} />
                     {!props.disabled ? <div title={Localization.getText("Delete")} style={{ cursor: "pointer", display: "flex", alignItems: "center" }} onClick={() => {
                        handleDelete(index);
                     }}>
                        <Trash />
                     </div> : <></>}

                  </div>
               ))}
               <div style={{ padding: "2px" }}>
                  <GlassButton onClick={handleAddNew}>{Localization.getText("Add")}</GlassButton>
               </div>
            </div>
         </ADModalBody>
         <ADModalFooter>
            {/* <GlassButtonRow> */}
            <GlassButton onClick={() => { dispatch(closeWindow(props.managedWindow.id)) }}>{Localization.getText("Cancel")}</GlassButton>
            <GlassButton disabled={props.disabled} onClick={confirmChanges}>{Localization.getText("Save")}</GlassButton>
            {/* </GlassButtonRow> */}
         </ADModalFooter>
      </AdvancedDragModal>
   )
}